'use client';
import React from 'react';
import { cn } from 'ui';

export const Attribute = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <div className={cn('space-y-1.5', className)}>{children}</div>;
};

export const AttributeLabel = ({ children }: { children: React.ReactNode }) => {
  return <p className='text-sm font-semibold'>{children}</p>;
};

export const AttributeValue = ({ children }: { children: React.ReactNode }) => {
  return <p className='text-sm'>{children}</p>;
};

export const buildSinisterDetailQueryKey = (id: string) => `sinister-${id}`;
